import React, { useState } from 'react'
import { PAGE_NUMBER, PAGE_SIZE } from '../../utils/constants';
import { useForm } from 'react-hook-form';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import { useGetStudentsUnsyncedQuery } from '../../hooks/useGetStudentsUnsyncedQuery';
import { SewingPinFilledIcon } from '@radix-ui/react-icons';
import toast from 'react-hot-toast';
import { useMutation } from 'react-query';
import { syncStudent } from '../../services/school/student/createStudent';
import { ConfirmAlertDialog } from '../../components/common/ConfirmAlertDialog';

const columnNamesMap: { [key: string]: string } = {
    name: 'Nome',
    courseName: 'Curso',
    nuit: 'Nuit',
    // isIntern:"Interno?",
};

export const SyncStudentsEsuraCentral = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [searchTerm, setSearchTerm] = useState('');
    const [syncSelected, setSyncSelected] = useState<any[] | null>(null);
    const mutation = useMutation(syncStudent, {
        onSuccess: () => {
            toast.success("Pedido de sincronizar enviado ao Esura Central!");
        },
        onError: () => {
            toast.error("Erro ao sincronizar estudante.");
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setCurrentPage(PAGE_NUMBER);
    };

    const handleSearch = (term: string) => {
        setSearchTerm(term);
        setCurrentPage(1);
    };
    const { control, handleSubmit, formState: { errors }, getValues, setValue, trigger, watch, reset, resetField } = useForm({
        defaultValues: {},
        mode: 'onBlur',
        reValidateMode: 'onBlur',
        shouldUseNativeValidation: false,
    });

    const onSubmit = handleSubmit(async (data: unknown) => {
    });
    const handleOnClickSyncAll = async (event: any) => {
        event.preventDefault();
        const submitData = {
            isSyncAll:true, 
            total : data?.totalItems,
        }
        try{
               await mutation.mutateAsync(submitData);   

        }catch (error) {
            toast.error("Erro ao sincronizar todos os estudantes");
        }
    }
    const { data, status } = useGetStudentsUnsyncedQuery({ PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm });
    const openSyncSelectedDialog = async (c: any[]) => {
        setSyncSelected(c);
    };
    const optionsForMassiveItems = [
        {
            label: 'Sincronizar selecionados',
            onClick: openSyncSelectedDialog,
            icon: <SewingPinFilledIcon />
        },
    ];

    const confirmSyncSelected = async () => {
        try {
            if (!syncSelected) return;
            const submitData = {
                isSyncAll:false,
                total: syncSelected.length,
                students: syncSelected
            }
            await mutation.mutateAsync(submitData);   
        } catch (error) {
            toast.error("Erro ao sincronizar selecionados");
        }
    };

    return (
        <Card>
            <Flex gap="4" direction="column">
                <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
                    <Button type="button" onClick={handleOnClickSyncAll} disabled={mutation.isLoading}>
                        {mutation.isLoading ? <Spinner loading /> : <SewingPinFilledIcon />}
                        Sincronizar todos
                    </Button>
                </Flex>
                <Lists
                    status={status}
                    TableComponent={() =>
                        <TableComponent
                            columns={Object.keys(columnNamesMap)}
                            items={data?.items.map(i=>{return {
                                ...i, 
                                isIntern: i.isNewStudent ? 'Sim' : 'Não',
                            }})}
                            options={[]}
                            columnNamesMap={columnNamesMap}
                            totalPages={data?.totalPages || 1}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            pageSize={pageSize}
                            onPageSizeChange={handlePageSizeChange}
                            onSearch={handleSearch}
                            search={searchTerm}
                            totalItems={data?.totalItems}
                            getValues={getValues}   
                            setValue={setValue}
                            control={control}
                            optionsForMassiveItems={optionsForMassiveItems}
                        />
                    }
                    handleClickCreate={undefined}
                />
                <ConfirmAlertDialog
                    open={!!syncSelected}
                    onOpenChange={(open) => !open && setSyncSelected(null)}
                    title="Esta operação é irreversível"
                    description="Os estudantes seleccionados serão enviados para sincronização no Esura Central."
                    confirmLabel="Sincronizar"
                    confirmColor="blue"
                    item={syncSelected}
                    onConfirm={confirmSyncSelected}
                    onCancel={() => setSyncSelected(null)} />
            </Flex>
        </Card>
    )
}
